import { makeObservable, observable } from "mobx";
import DefectData from "./defectData";
import { authStore } from "../store/authStore";
import { FilterItem } from "../api/Types";
import { FilterCondition } from "../constants/Enums";
import { ExpandableKeys } from "./core";

class AgreementDefectData extends DefectData {
  filterItems: FilterItem[] = [
    {
      fieldName: "isValid",
      value: true,
      condition: FilterCondition.Equal,
    },
    {
      fieldName: "eventTypeId",
      value: 3,
      condition: FilterCondition.NotEqual,
    },
    {
      fieldName: "incidentStatusId",
      value: [2,5,6],
      condition: FilterCondition.In,
    },
  ];
  selectedRows = new ExpandableKeys();

  constructor() {
    super();
    this.dataLable = "Реестр согласованных";
    makeObservable(
      this,
      {
        selectedRows: observable,
      }
    )
  }
}

const agreementDefectDataStore = new AgreementDefectData();
export default agreementDefectDataStore;
